/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Button from '../../../components/general/button';
import Chevron from '../../../components/general/navigation-chevron';

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	background: #fff;
	min-height: 63px;
	padding-right: 36px;
`;

const CompleteButtton = styled(Button)`
 	display: flex;
 	align-items: center;
 	justify-content: center;

 	width: 178px;
 	height: auto;
 	font-size: 14px;
 	border-width: 2px;
 `;

const ButtonGroup = styled.div`
	align-self: flex-end;
	display: flex;
`;

const ActionButton = styled.button`
	display:flex;
	justify-content: center;
	align-items: center;
	min-width: 113px;
	min-height: 41px;
	color: ${({color}) => color};
	background: ${({background}) => background};
	padding: 0 18px;
	border: none;
	${({disabled}) => disabled ? 'opacity: .4;' : ''}

	& img {
		margin-right: 4px;
	}

	& + button {
		margin-right: 1px;
	}
`;

const ActionBar = ({
                       buttons,
                       currentView,
                       complete,
                       pause,
                       workgroupview,
                       setworkgroup,
                   }) => (
    <Wrapper>
        {buttons && (
            <ButtonGroup>
                {buttons.map((button, index) => {
                    const isActive = currentView === button.id;

                    return (
                        <ActionButton
                            key={`action-button-${index}`}
                            disabled={button.disabled}
                            color={isActive ? button.activeColor : button.color}
                            background={isActive ? button.activeBackground : button.background}
                            onClick={button.action}
                        >
                            <img src={isActive ? button.activeIcon : button.icon}/>

                            <span>{button.label}</span>
                        </ActionButton>
                    );
                })}
            </ButtonGroup>
        )}

        {pause && !workgroupview && <CompleteButtton onClick={pause}>
            Auftrag pausieren

            <Chevron/>
        </CompleteButtton>}
        {setworkgroup && !workgroupview && <CompleteButtton onClick={setworkgroup}>
            Arbeitsgruppe freigeben

            <Chevron/>
        </CompleteButtton>}
        {!workgroupview && <CompleteButtton onClick={complete}>
            Auftrag beenden

            <Chevron/>
        </CompleteButtton>}
    </Wrapper>
);

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/task/working/action-bar.js